import { apiSlice } from "../../apiSlice";
export const repfinacApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getClientGraphicById: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/getClientById`,
        method: "GET",
        params: parameters,
        headers: { modulecima: "reportxx" },
      }),
    }),
    excelReintegro: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/generateExcel`,
        method: "POST",
        body: parameters,
      }),
    }),
    reportHP: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/reportHP`,
        method: "GET",
        params: parameters,
      }),
    }),
    getInvoiceById: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/getInvoiceById`,
        method: "GET",
        params: parameters,
      }),
    }),
    generateReporIppcc: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/generateReporIppcc`,
        method: "POST",
        body: parameters,
      }),
    }),
    reportApple: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/generateReportApple`,
        method: "GET",
        params: parameters,
      }),
    }),
    reportLG: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/generateReportLG`,
        method: "GET",
        params: parameters,
      }),
    }),
    reportDetailedBilling: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/detailedBilling`,
        method: "GET",
        params: parameters,
      }),
    }),
    proformasBavaria: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/ProformasBavaria`,
        method: "GET",
        params: parameters,
      }),
    }),
    reportSiemens: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/generateReportSiemens`,
        method: "GET",
        params: parameters,
      }),
    }),
    getReportLink: builder.query({
      query: () => ({
        url: `/Reportxx/Repfinac/getReportLink`,
        method: "GET",
      }),
    }),
    generateReportCartera: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/generateReportCartera`,
        method: "POST",
        body: parameters,
      }),
    }),
    getClientByGroup: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/getClientByGroup`,
        method: "GET",
        params: parameters,
        headers: { modulecima: "reportxx" },
      }),
    }),
    reportTexmoda: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/generateReportTexmoda`,
        method: "GET",
        params: parameters,
      }),
    }),
        getProformaById: builder.mutation({
      query: (parameters) => ({
        url: `/Reportxx/Repfinac/getProformaById`,
        method: "GET",
        params: parameters,
      }),
    }),
  }),
});

export const {
  useGetClientGraphicByIdMutation,
  useExcelReintegroMutation,
  useReportHPMutation,
  useGetInvoiceByIdMutation,
  useGenerateReporIppccMutation,
  useReportAppleMutation,
  useReportLGMutation,
  useReportDetailedBillingMutation,
  useProformasBavariaMutation,
  useReportSiemensMutation,
  useLazyGetReportLinkQuery,
  useGenerateReportCarteraMutation,
  useGetClientByGroupMutation,
  useReportTexmodaMutation,
  useGetProformaByIdMutation
} = repfinacApiSlice;
